<template>
  <div
    id="orderDeliveryModal"
    class="modal fade"
  >
    <div
      id="print-area"
      class="modal-dialog modal-full"
      style="max-width: 850px"
    >
      <div class="modal-content">
        <!-- style="border-style: dashed; border-width: 1px" -->
        <div class="modal-header">
          <button
            id="close-button"
            type="button"
            class="close"
            @click="closeModal('orderDeliveryModal')"
          >
            &times;
          </button>
        </div>

        <table
          style="width: 100%"
          id="head-table"
        >
          <tr>
            <td style="padding-left: 20px">
              <img
                style="width: 110px; height: 100px"
                id="header-img"
                src="../../../assets/images/black_shipzone.png"
                alt=""
              />
            </td>
            <td>
              <table
                id="company-info"
                style="width: 100%; margin-left: 0px"
              >
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 20px">
                    {{ companyData.company_name }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 20px">
                    {{ companyData.company_address }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 20px">
                    {{ companyData.company_email }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 20px">
                    {{ companyData.phone_number }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <div class="modal-body mx-2">
          <table
            style="width: 100%"
            id="print-table1"
          >
            <tr>
              <td
                class="text-align-center"
                style="border: 1px solid #212121; padding: 6px"
              >
                <strong style="font-size: 20px">
                  Order Delivery Invoice
                </strong>
              </td>
            </tr>
          </table>

          <table class="app-print-table app-print-table-all-border">
            <tr>
              <td class="w-50">Customer Name</td>
              <td class="w-50">{{ viewData.order.customer.full_name }}</td>
            </tr>
            <tr>
              <td class="w-50">Customer Phone</td>
              <td class="w-50">{{ viewData.order.customer.phone_number }}</td>
            </tr>
            <tr>
              <td class="w-50">Customer Phone 2</td>
              <td class="w-50">{{ viewData.order.customer.phone_number_2 }}</td>
            </tr>
            <tr>
              <td class="w-50">Address</td>
              <td class="w-50">{{ viewData.order.customer.address }}</td>
            </tr>
            <tr>
              <td class="w-50">Delivery Price</td>
              <td class="w-50">${{ viewData.delivery_price }}</td>
            </tr>
            <tr>
              <td class="w-50">Invoice No.</td>
              <td class="w-50">{{ viewData.invoice_number }}</td>
            </tr>
          </table>

          <div style="float: right">
            <v-btn
              @click="printInvoice"
              id="print-button"
              style="height:auto"
              outline
              color="primary"
            >Print</v-btn>
          </div>
        </div>

        <!-- PRINTABLE TABLEs -->
        <!-- <table
          id="head-table"
          style="padding-top: 30px; width: 100%"
          class="show-in-print"
        >
          <tr>
            <td style="padding-left: 20px">
              <img
                style="width: 110px; height: 100px"
                id="header-img"
                src="../../../assets/images/black_shipzone.png"
                alt=""
              />
            </td>
            <td>
              <table
                id="company-info"
                style="width: 100%; margin-left: 0px"
              >
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 10px">
                    {{ companyData.company_name }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 10px">
                    {{ companyData.company_address }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 10px">
                    {{ companyData.company_email }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 10px">
                    {{ companyData.phone_number }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <div class="modal-body show-in-print">
          <table
            style="width: 100%"
            id="print-table1"
          >
            <tr>
              <td id="credit-table-header">
                <strong style="font-size: 20px">
                  Order Delivery Invoice
                </strong>
              </td>
            </tr>
          </table>

          <table
            style="width: 100%"
            id="print-table2"
          >
            <tr>
              <td >
                Customer Name
              </td>
              <td >
                {{ viewData.order.customer.full_name }}
              </td>
            </tr>
            <tr>
              <td >
                Customer Phone
              </td>
              <td >
                {{ viewData.order.customer.phone_number }}
              </td>
            </tr>
            <tr>
              <td >
                Address
              </td>
              <td >
                {{ viewData.order.customer.address }}
              </td>
            </tr>
            <tr>
              <td >
                Delivery Price
              </td>
              <td >
                {{ viewData.delivery_price }}
              </td>
            </tr>
          </table>
        </div> -->

        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['viewData', 'closeModal', 'companyData'],

  mounted() {
    let theModal = document.querySelector('.modal')
    theModal.style.overflowX = 'auto'
    $('.show-in-print').hide()
  },

  methods: {
    printInvoice() {
      $('#close-button').hide()
      $('#print-button').hide()
      $('.show-in-print').show()

      $('#print-area').printMe({ path: ['assets/ltr/css/print_style.css'] })

      $('#close-button').show()
      $('#print-button').show()
      $('.show-in-print').hide()
    }
  }
}
</script>

<style>
#print-area {
  max-width: 850px;
}

.modal {
  text-align: center;
  padding: 0 !important;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

@media screen and (max-width: 650px) {
  #credit-table-header {
    width: 500px;
    padding-left: 10px;
  }
  #price-section2 {
    width: 500px;
    padding-left: 10px;
    padding-top: 10px;
    font-size: 15px;
  }
  #price-section {
    width: 280px;
  }
  #company-info {
    width: 100%;
  }
  #header-img {
    width: 60px;
    height: 60px;
  }
  #print-area {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderDelivery/orderDeliveryInvoice.vue